import type { DamageType } from "../damageType";
import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { DeadPlant } from "./deadPlant";

export class Tree extends DestroyableObstacle {
	static key = "Tree";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.LEAF_DEBRIS;
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		const remnant = new DeadPlant(this.xy);
		this.board!.addThing(remnant);
		super.onZeroHp(source, type);
	}

	static deserialize(data: any): Tree {
		const t = new Tree(deserializeXY(data.xy));
		t.restoreBaseFields(data);
		return t;
	}
}
